export async function pollTaskStatus(URI, taskId, token, options = {}) {
  const { timeoutMs = 60000, intervalMs = 2000 } = options;
  const start = Date.now();
  let lastError = null;

  while (Date.now() - start < timeoutMs) {
    try {
      const response = await fetch(`${URI}helper/task-status/${taskId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      });

      if (response.status === 404) {
        await new Promise((resolve) => setTimeout(resolve, intervalMs));
        continue;
      }

      if (!response.ok) {
        throw new Error(`Status check failed: ${response.status}`);
      }

      const data = await response.json();
      const terminalStates = ["success", "error", "failed", "timeout"];
      if (terminalStates.includes(data.status)) {
        return data;
      }
    } catch (error) {
      console.error("❌ Task status polling error:", error);
      lastError = error;
    }

    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }

  throw lastError || new Error("Task status polling timed out");
}
